import appParamsService from './appParamsService'

if (!window.__ENV_CONFIG__) console.error('Client ENV config is not hydrated.')

const envConfig = { ...window.__ENV_CONFIG__ }

export { envConfig, appParamsService }
